module.exports = __webpack_public_path__ + "img/equalizer.caa8cd60.svg";